import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    private toastController: ToastController,
    public alertController:AlertController,
  ) { }

  async presentToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'middle',
      //color: 'success',//verde
      cssClass: 'presentToastCss',
    });
    toast.present();
  }

  async successToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      color: 'success',//verde
      cssClass: 'successToastCss',
    });
    toast.present();
  }

  async errorToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      position: 'bottom',
      color: 'danger',//rosso
      cssClass: 'errorToastCss',
    });
    toast.present();
  }

  async presentToastWithOptions(header:any,message:any) {
    const toast = await this.toastController.create({
      header: header,
      message: message,
      position: 'middle',
      cssClass: 'presentToastCss',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        }
      ]
    });
    await toast.present();
    const { role } = await toast.onDidDismiss();
    //console.log('onDidDismiss resolved with role', role);
  }

  async presentAlertWithOptions(header:any,message:any) {
    //message=`<ion-img class="my-yow-imgA" src={{env.IMG_FOLDER}}yowORIG.png></ion-img>`;
    const alert = await this.alertController.create({
      header: header,
      message: message,
      cssClass: 'my-alert',
      buttons: [
        {
          text: "Ok",
          cssClass: 'my-alertEsc',
          role: 'cancel',
          handler: blah => {
            //console.log('Confirm Cancel: blah');
          },
        },
      ],
    });
    await alert.present();
  }


}
